// Role → capability mapping. Pure and unit-tested; the UI gates every mutation
// button on these flags so a viewer sees a read-only app (docs/06). Real
// enforcement lives in the API service layer — this is UX, not security.

import { ROLE_RANK, type Role } from '@seencast/shared';

export interface Permissions {
  role: Role;
  isViewer: boolean;
  /** Create/edit/delete content: screens, media, playlists, schedules, groups, pairing. */
  canManageContent: boolean;
  /** Invite teammates, change roles, edit org profile. */
  canManageTeam: boolean;
  /** Alias kept for readability at call sites that edit org-level settings. */
  canManageOrg: boolean;
  /** Any mutation at all — handy for hiding empty toolbars. */
  canMutate: boolean;
  isSuperadmin: boolean;
}

export function computePermissions(role: Role, isSuperadmin = false): Permissions {
  const rank = ROLE_RANK[role];
  const canManageContent = rank >= ROLE_RANK.editor;
  const canManageTeam = rank >= ROLE_RANK.admin;
  return {
    role,
    isViewer: role === 'viewer',
    canManageContent,
    canManageTeam,
    canManageOrg: canManageTeam,
    canMutate: canManageContent,
    isSuperadmin,
  };
}
